import { FC, useCallback, useEffect, useRef } from "react";
import Plotly from "plotly.js-basic-dist";
import createPlotlyComponent from "react-plotly.js/factory";
const Plot = createPlotlyComponent(Plotly);


const useResizePlot = (plotRef: React.RefObject<HTMLDivElement>) => {
    const resizePlot = useCallback(() => {
        if (plotRef.current) {
            const plotlyElement = plotRef.current.querySelector('.js-plotly-plot') as Plotly.PlotlyHTMLElement | null;
            if (plotlyElement) {
                Plotly.Plots.resize(plotlyElement);
            }
        }
    }, [plotRef]);

    useEffect(() => {
        const handleFocus = () => {
            resizePlot();
        };

        const resizeObserver = new ResizeObserver(() => {
            resizePlot();
        });

        if (plotRef.current) {
            resizeObserver.observe(plotRef.current);
        }

        window.addEventListener('focus', handleFocus);

        return () => {
            window.removeEventListener('focus', handleFocus);
            if (plotRef.current) {
                resizeObserver.unobserve(plotRef.current);
            }
        };
    }, [plotRef, resizePlot]);
};

const PlotlyChart: FC<any> = ({ plotData }) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useResizePlot(containerRef);

    return <div id="plotly-chart" ref={containerRef} style={{ width: '100%', minWidth: '500px', height: '450px', marginBottom: '15px' }}>
        <Plot
            data={plotData.data}
            layout={plotData.layout}
            config={{ responsive: true }}
            useResizeHandler
            style={{ width: '100%', height: '450px' }}/>
    </div>
}

export default PlotlyChart;